module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sd-header'), _vm._v(" "), _c('div', {
    staticClass: "address-view",
    staticStyle: {
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "block block1"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("寄送地址")]), _vm._v(" "), _c('table', [_c('colgroup', {
    staticStyle: {
      "width": "300px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "500px"
    }
  }), _vm._v(" "), _c('colgroup', {
    staticStyle: {
      "width": "200px"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.addressList), function(item) {
    return _c('tr', {
      class: {
        'on': item.id == _vm.selectAddressId
      },
      on: {
        "click": function($event) {
          return _vm.selectAddress(item)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.receiverName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userPhone))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userAdd))]), _vm._v(" "), _c('td', [(item.haveDefault != 2) ? _c('p', {
      staticClass: "type to_default",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 1, $event)
        }
      }
    }, [_vm._v("设为默认")]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "type default"
    }, [_vm._v("默认地址")]), _vm._v(" "), _c('a', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.updateAddress(item, $event)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" |\n                          "), _c('a', {
      staticClass: "opra",
      on: {
        "click": function($event) {
          return _vm.deleteAddress(item, $event)
        }
      }
    }, [_vm._v("删除")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addressList.length <= 5),
      expression: "addressList.length <= 5"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("新增地址"), _c('i')])]), _vm._v(" "), _c('div', {
    staticClass: "block block2"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("发票信息管理")]), _vm._v(" "), _vm._l((_vm.invoiceList), function(item) {
    return _c('ul', {
      staticClass: "invoice",
      class: {
        'on': item.id == _vm.selectInvoiceId
      },
      on: {
        "click": function($event) {
          return _vm.selectInvoice(item, $event)
        }
      }
    }, [_c('li', [_c('ul', {
      staticClass: "info_ul"
    }, [_c('li', [_c('span', [_vm._v("发票抬头：")]), _vm._v(" " + _vm._s(item.invoiceTitle))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("发票类型：")]), _vm._v(" " + _vm._s(_vm.options._invoiceType[item.invoiceType]))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("纳税人识别号：")]), _vm._v(" " + _vm._s(item.identifyNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册电话：")]), _vm._v(" " + _vm._s(item.regPhone))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("开户银行：")]), _vm._v(" " + _vm._s(item.regBank))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("银行号码：")]), _vm._v(" " + _vm._s(item.bankNumber))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("注册地址：")]), _vm._v(" " + _vm._s(item.regAddress))])])]), _vm._v(" "), _c('li', {
      staticClass: "invoice-info"
    }, [_c('a', {
      staticClass: "btn mark",
      staticStyle: {
        "color": "#00A0E9"
      },
      on: {
        "click": function($event) {
          return _vm.updateInvoice(item, $event)
        }
      }
    }, [_vm._v("修改")]), _vm._v(" "), _c('a', {
      staticClass: "btn mark",
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.deleteInvoice(item, $event)
        }
      }
    }, [_vm._v("删除")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault != 2),
        expression: "item.haveDefault != 2"
      }],
      staticClass: "btn mark",
      on: {
        "click": function($event) {
          return _vm.setDefault(item, 2, $event)
        }
      }
    }, [_vm._v("设为默认")]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.haveDefault == 2),
        expression: "item.haveDefault == 2"
      }],
      staticClass: "mark"
    }, [_vm._v("默认发票")])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceList.length <= 5),
      expression: "invoiceList.length <= 5"
    }],
    staticClass: "add",
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("新增发票 "), _c('i')])], 2), _vm._v(" "), _c('div', {
    staticClass: "remark"
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "margin-right": "200px"
    }
  }, [_vm._v("项目名称："), _c('span', [_vm._v(_vm._s(_vm.invoiceName))])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("发票金额："), _c('span', {
    staticStyle: {
      "color": "#FF0415"
    }
  }, [_vm._v("￥" + _vm._s(_vm.getCustomerAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "first"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("发票备注：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceRemark),
      expression: "invoiceRemark"
    }],
    domProps: {
      "value": (_vm.invoiceRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoiceRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "second"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("其他备注：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherRemark),
      expression: "otherRemark"
    }],
    domProps: {
      "value": (_vm.otherRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherRemark = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.submitInvoice(1)
      }
    }
  }, [_vm._v("开纸质发票")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.submitInvoice(2)
      }
    }
  }, [_vm._v("开电子发票")])])]), _vm._v(" "), _c('add-address', {
    ref: "addressCtrl",
    on: {
      "on-success": _vm.getAddressList
    }
  }), _vm._v(" "), _c('add-invoice', {
    ref: "invoceCtrl",
    on: {
      "on-success": _vm.getInvoiceList
    }
  })], 1), _vm._v(" "), _c('sd-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("收件人姓名")]), _vm._v(" "), _c('td', [_vm._v("电话号码")]), _vm._v(" "), _c('td', [_vm._v("地址")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b4186a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InvoiceView.vue
// module id = 857
// module chunks = 1